import { httpClient } from '../lib/http-client';
import { Departamento } from '../types';

/**
 * Service para gerenciamento de departamentos
 */
export class DepartamentosService {
  static async getDepartamentos(): Promise<Departamento[]> {
    return httpClient.get<Departamento[]>('/api/departamentos');
  }

  static async getDepartamento(id: number): Promise<Departamento> {
    return httpClient.get<Departamento>(`/api/departamentos/${id}`);
  }

  static async createDepartamento(data: Partial<Departamento>): Promise<Departamento> {
    return httpClient.post<Departamento>('/api/departamentos', data);
  }

  static async updateDepartamento(
    id: number,
    data: Partial<Departamento>
  ): Promise<Departamento> {
    return httpClient.put<Departamento>(`/api/departamentos/${id}`, data);
  }

  static async deleteDepartamento(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/departamentos/${id}`);
  }

  static async toggleDepartamentoStatus(id: number): Promise<{ ativo: number }> {
    return httpClient.patch<{ ativo: number }>(`/api/departamentos/${id}/toggle-status`);
  }
}

